<div class="scim-administration">
	<div class="service-header-wrapper">
		<h2 class="mat-heading service-title">{{ 'scim-administration.title' | translate }}</h2>
		<div class="service-header-buttons">
			<div class="acies-density-high acies-list-search-field">
				<mat-form-field>
					<input matInput (keyup)="applyFilter($event)" [placeholder]="'scim-administration.search.placeholder' | translate" [value]="searchValue" #searchInput />
					<button mat-icon-button matPrefix>
						<mat-icon svgIcon="acies_search"></mat-icon>
					</button>
				</mat-form-field>
			</div>
			<button mat-raised-button color="primary" (click)="loadToken()" [disabled]="isLoadingToken">
				{{ 'scim-administration.token.getToken' | translate }}
			</button>
		</div>
	</div>

	@if (isLoadingToken) {
		<div class="loading-overlay token-loading">
			<img class="spinner" src="./assets/spinner2.gif" />
		</div>
	}

	<mat-tab-group [selectedIndex]="selectedTabIndex" (selectedTabChange)="onTabChange($event)">
		<!-- Users Tab -->
		<mat-tab [label]="'scim-administration.tabs.users' | translate">
			<div class="tab-content">
				@if (isLoadingUsers) {
					<div class="loading-overlay">
						<img class="spinner" src="./assets/spinner2.gif" />
					</div>
				}
				<app-generictable [tableSource]="usersTableSource" [tableColumns]="usersColumns" [rowActions]="usersRowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
			</div>
		</mat-tab>

		<!-- Groups Tab -->
		<mat-tab [label]="'scim-administration.tabs.groups' | translate">
			<div class="tab-content">
				@if (isLoadingGroups) {
					<div class="loading-overlay">
						<img class="spinner" src="./assets/spinner2.gif" />
					</div>
				}
				<app-generictable [tableSource]="groupsTableSource" [tableColumns]="groupsColumns" [rowActions]="groupsRowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
			</div>
		</mat-tab>

		<!-- Policy Maps Tab -->
		<mat-tab [label]="'scim-administration.tabs.policyMaps' | translate">
			<div class="tab-content">
				@if (isLoadingPolicyMaps) {
					<div class="loading-overlay">
						<img class="spinner" src="./assets/spinner2.gif" />
					</div>
				}
				<div class="tab-actions">
					<button mat-raised-button color="primary" (click)="openCreatePolicyMap()" [disabled]="!isDataReadyForCreatePolicyMap">
						{{ 'scim-administration.policyMaps.actions.create' | translate }}
					</button>
				</div>
				<app-generictable [tableSource]="policyMapsTableSource" [tableColumns]="policyMapsColumns" [rowActions]="policyMapsRowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
			</div>
		</mat-tab>

		<!-- Policies Tab -->
		<mat-tab [label]="'scim-administration.tabs.policies' | translate">
			<div class="tab-content">
				@if (isLoadingPolicies) {
					<div class="loading-overlay">
						<img class="spinner" src="./assets/spinner2.gif" />
					</div>
				}
				<div class="tab-actions">
					<button mat-raised-button color="primary" (click)="openCreatePolicy()">
						{{ 'scim-administration.policies.actions.create' | translate }}
					</button>
				</div>
				<app-generictable [tableSource]="policiesTableSource" [tableColumns]="policiesColumns" [rowActions]="policiesRowActions" (menuEmitter)="handleRowMenuAction($event)"></app-generictable>
			</div>
		</mat-tab>
	</mat-tab-group>
</div>
